import { action } from 'satcheljs';
import { WORKFLOW_STATES } from 'mini-diagnostics/lib/schema/WorkflowStates';

/**
 * Trigger an action to track the activities in a workflow
 * It requires one to pass the @name field which is the name of the
 * workflow
 */
export const trackActivity = action(
    '__DIAGNOSTICS_TRACK_ACTIVITY',
    (action: {
        workflowName: string;
        workflowState: WORKFLOW_STATES;
        payload?: { [key: string]: any };
    }) => action
);
